import { render, staticRenderFns } from "./DocumentoInput.vue?vue&type=template&id=38c46d4f"
import script from "./DocumentoInput.vue?vue&type=script&lang=js"
export * from "./DocumentoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports